import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

import PropTypes from 'prop-types';
// import { rel } from '../../utils/rel';

/**
 * 定义 委员搜索 组件
 */

class Search extends React.PureComponent {
    async componentDidMount() {
        // this.searchWy();
    }
    state = {
        inputValue: '',
    };
    handleGetInputValue = event => {
        this.setState({
            inputValue: event.target.value,
        });
    };
    handleKeyDown = event => {
        if (event.keyCode === 13) {
            this.props.keyDownHandler(this.state.inputValue);
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { clickHandler } = this.props;

        return (
            <div className={styles.search}>
                <span style={{ float: 'left', display: 'inline-block' }}>
                    <input
                        className={styles.input}
                        type="text"
                        value={this.state.inputValue}
                        onChange={this.handleGetInputValue}
                        onKeyDown={this.handleKeyDown}
                    />
                </span>
                <button className={styles.searchBut} onClick={() => clickHandler(this.state.inputValue)}>
                    搜索
                </button>
            </div>
        );
    }
}

Search.propTypes = { clickHandler: PropTypes.func, keyDownHandler: PropTypes.func };

export default errorBoundary(Search);
